import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import RoomProvider from "./context/RoomContext";
import AuthProvider from "./context/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <HelmetProvider>
      <AuthProvider>
        <RoomProvider>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </RoomProvider>
      </AuthProvider>
    </HelmetProvider>
  </GoogleOAuthProvider>
);
